import { atom } from 'jotai';
import { PaymentSection } from '~/pages/Payment/@types';

export const latestScrollY = atom(0);
export const paymentScrollSection = atom<PaymentSection | undefined>(undefined);
